require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./courses-web-3-101-explore-cryptocurrencies-and-web-3-careers.json") })
        }
      }, "path---courses-web-3-101-explore-cryptocurrencies-and-web-3-careers");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---courses-web-3-101-explore-cryptocurrencies-and-web-3-careers!./.cache/json/courses-web-3-101-explore-cryptocurrencies-and-web-3-careers.json
// module id = 1197
// module chunks = 231608221292675